export const PRODUCT_NAME_MAX_LENGTH = 60;

const ALLOWED = "\\p{L}\\p{N} .,'\"()&%°\\-+/";
const VALID_NAME = new RegExp(`^[${ALLOWED}]+$`, 'u');
const DISALLOWED = new RegExp(`[^${ALLOWED}]`, 'gu');
const REPLACEMENTS = [
    [/;/g, ','],
    [/\s*:\s*/g, ' - '],
    [/[’‘]/g, "'"],
    [/«\s*/g, '"'],
    [/\s*»/g, '"'],
    [/[“”]/g, '"'],
    [/[–—]/g, '-'],
    [/_/g, ' '],
];

export function isValidProductName(name) {
    return VALID_NAME.test(String(name ?? ''));
}

export function sanitizeProductName(name) {
    const replaced = REPLACEMENTS.reduce((text, [pattern, replacement]) => text.replace(pattern, replacement), String(name ?? ''));
    return replaced
        .replace(/\s+/g, ' ')
        .replace(DISALLOWED, '')
        .replace(/ {2,}/g, ' ')
        .trim();
}
